import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";

// Layout
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import FloatingWhatsApp from "./components/layout/FloatingWhatsApp";

// Pages
import Home from "./pages/Home";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Transformations from "./pages/Transformations";
import Nutrition from "./pages/Nutrition";
import About from "./pages/About";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import FloatingCTA from "./components/layout/FloatingCTA";
import ScrollToTop from "../src/services/ScrollToTop";
import AdsLandingPage from "./pages/AdsLandingPage";
import NutritionPlans from "./pages/NutritionPlans";

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-[var(--dvx-bg)] transition-colors duration-300">
        <div className="noise-overlay" />
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <FloatingCTA />
          <FloatingWhatsApp />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/:slug" element={<ProgramDetail />} />
              <Route path="/transformations" element={<Transformations />} />
              <Route path="/nutrition" element={<Nutrition />} />
              <Route path="/nutrition-plans" element={<NutritionPlans />} />
              <Route path="/about" element={<About />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/ads" element={<AdsLandingPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
